module.exports = __webpack_public_path__ + "static/media/10256.72a258ac.jpg";